module.exports = __webpack_public_path__ + "static/img/check3.84aaf038.jpg";